import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { InputFieldBaseComponent } from './input-field-base.component';
import { MatError, MatFormField, MatLabel, MatSuffix, SubscriptSizing } from '@angular/material/form-field';
import { NgStyle } from '@angular/common';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'mng-inputfield-string-clearable',
  imports: [
    MatFormField,
    NgStyle,
    ExtendedModule,
    MatSuffix,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatIcon,
    MatTooltip,
    MatError
  ],
  template: `
    <mat-form-field
      style="width: 100%; {{ inputTextStyle() }}"
      [ngStyle]="ngStyle()"
      [floatLabel]="floatLabel()"
      [appearance]="appearance()"
      [subscriptSizing]="subscriptSizing()"
    >
      @if (field().label) {
        <mat-label>{{ field().label }}</mat-label>
      }

      <input
        [id]="field().id"
        matInput
        type="text"
        [placeholder]="field().placeHolder"
        [formControl]="field().control"
        autocomplete="off"
        (keyup)="onKeyEvent($event)"
      />

      @if (field().control.value) {
        <mat-icon
          svgIcon="cancel"
          class="cancel-icon"
          matIconSuffix
          (click)="clearFilter()"
          matTooltip="Filter löschen"
        />
      }

      @if (hasErrors) {
        <mat-error> {{ validationMessage }} </mat-error>
      }
    </mat-form-field>
  `,
  styles: `
    .cancel-icon {
      color: gray;
      padding: 0 2px 0 0 !important;
      &:hover {
        cursor: pointer;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldStringClearableComponent extends InputFieldBaseComponent {
  readonly subscriptSizing = input<SubscriptSizing>('dynamic');

  clearFilter() {
    this.field().control.reset();
  }
}
